document.addEventListener('DOMContentLoaded', function() {
	initAOSClasses();
  });
function initAOSClasses() {
	let all_firstslide = document.querySelectorAll(".aos-fade-left-five-h");
	let all_secondslide = document.querySelectorAll(".aos-fade-left-eight-h");
	let all_thirdslide = document.querySelectorAll(".aos-fade-left-twelve-h");
	//  Fade left animation
	let aos_fade_left_animation = document.querySelectorAll(".aos-fade-left");
	//  Fade right animation
	let aos_fade_right_animation = document.querySelectorAll(".aos-fade-right");
	//  Fade right animation slow
	let aos_fade_right_slow_animation = document.querySelectorAll(".aos-fade-right-slow");
	//  Fade up animation
	let aos_fade_up_animation = document.querySelectorAll(".aos-fade-up");
	//  Fade down animation
	let aos_fade_down_animation = document.querySelectorAll(".aos-fade-down");
	//  Zoom in animation
	let aos_zoom_in_animation = document.querySelectorAll(".aos-zoom-in");
	//  Zoom out animation
	let aos_zoom_out_animation = document.querySelectorAll(".aos-zoom-out");

	//  Flip left animation
	let aos_flip_left_animation = document.querySelectorAll(".aos-flip-left");
	//  Flip right animation
	let aos_flip_right_animation = document.querySelectorAll(".aos-flip-right");
	//  Flip up out animation
	let aos_flip_up_animation = document.querySelectorAll(".aos-flip-up");
	//  Flip down animation
	let aos_flip_down_animation = document.querySelectorAll(".aos-flip-down");
	//  Zoom in up animation
	let aos_zoom_in_up_animation = document.querySelectorAll(".aos-zoom-in-up");
	//  Zoom in down animation
	let aos_zoom_in_down_animation = document.querySelectorAll(".aos-zoom-in-down");
	//  Zoom in left animation
	let aos_zoom_in_left_animation = document.querySelectorAll(".aos-zoom-in-left");
	//  Zoom in right animation
	let aos_zoom_in_right_animation = document.querySelectorAll(".aos-zoom-in-right");
  
	if (all_firstslide) {
	  for (let i = 0; i < all_firstslide.length; i++) {
		all_firstslide[i].setAttribute("data-aos", "fade-left");
		all_firstslide[i].setAttribute("data-aos-duration", "500");
		// all_firstslide[i].setAttribute("data-aos-offset","100");
	  }
	}
	if (all_secondslide) {
	  for (let i = 0; i < all_secondslide.length; i++) {
		all_secondslide[i].setAttribute("data-aos", "fade-left");
		all_secondslide[i].setAttribute("data-aos-duration", "800");
		// all_secondslide[i].setAttribute("data-aos-offset","400");
	  }
	}
	if (all_thirdslide) {
	  for (let i = 0; i < all_thirdslide.length; i++) {
		all_thirdslide[i].setAttribute("data-aos", "fade-left");
		all_thirdslide[i].setAttribute("data-aos-duration", "1200");
		// all_thirdslide[i].setAttribute("data-aos-offset","800");
	  }
	}
  
	//  Fade left animation
	if (aos_fade_left_animation) {
	  for (let i = 0; i < aos_fade_left_animation.length; i++) {
		aos_fade_left_animation[i].setAttribute("data-aos", "fade-left");
	  }
	}
	//  Fade right animation
	if (aos_fade_right_animation) {
	  for (let i = 0; i < aos_fade_right_animation.length; i++) {
		aos_fade_right_animation[i].setAttribute("data-aos", "fade-right");
	  }
	}
	//  Fade right animation slow
	if (aos_fade_right_slow_animation) {
	  for (let i = 0; i < aos_fade_right_slow_animation.length; i++) {
		aos_fade_right_slow_animation[i].setAttribute("data-aos", "fade-right");
		aos_fade_right_slow_animation[i].setAttribute(
		  "data-aos-duration",
		  "1200"
		);
	  }
	}
	//  Fade up animation
	if (aos_fade_up_animation) {
	  for (let i = 0; i < aos_fade_up_animation.length; i++) {
		aos_fade_up_animation[i].setAttribute("data-aos", "fade-up");
	  }
	}
	//  Fade down animation
	if (aos_fade_down_animation) {
	  for (let i = 0; i < aos_fade_down_animation.length; i++) {
		aos_fade_down_animation[i].setAttribute("data-aos", "fade-down");
	  }
	}
	//  Zoom in animation
	if (aos_zoom_in_animation) {
	  for (let i = 0; i < aos_zoom_in_animation.length; i++) {
		aos_zoom_in_animation[i].setAttribute("data-aos", "zoom-in");
	  }
	}
	//  Zoom out animation
	if (aos_zoom_out_animation) {
	  for (let i = 0; i < aos_zoom_out_animation.length; i++) {
		aos_zoom_out_animation[i].setAttribute("data-aos", "zoom-out");
	  }
	}
	//  Flip left animation
	if (aos_flip_left_animation) {
		for (let i = 0; i < aos_flip_left_animation.length; i++) {
			aos_flip_left_animation[i].setAttribute("data-aos", "flip-left");
		}
	  }
	//  Flip right animation
	if (aos_flip_right_animation) {
		for (let i = 0; i < aos_flip_right_animation.length; i++) {
			aos_flip_right_animation[i].setAttribute("data-aos", "flip-right");
		}
	  }
	//  Flip up out animation
	if (aos_flip_up_animation) {
		for (let i = 0; i < aos_flip_up_animation.length; i++) {
			aos_flip_up_animation[i].setAttribute("data-aos", "flip-up");
		}
	  }
	  //  Flip down animation
	if (aos_flip_down_animation) {
		for (let i = 0; i < aos_flip_down_animation.length; i++) {
			aos_flip_down_animation[i].setAttribute("data-aos", "flip-down");
		}
	  }
	  //  Zoom in up animation
	if (aos_zoom_in_up_animation) {
		for (let i = 0; i < aos_zoom_in_up_animation.length; i++) {
			aos_zoom_in_up_animation[i].setAttribute("data-aos", "zoom-in-up");
		}
	  }
	  //  Zoom in down animation
	if (aos_zoom_in_down_animation) {
		for (let i = 0; i < aos_zoom_in_down_animation.length; i++) {
			aos_zoom_in_down_animation[i].setAttribute("data-aos", "zoom-in-down");
		}
	  }
	 //  Zoom in left animation
	if (aos_zoom_in_left_animation) {
		for (let i = 0; i < aos_zoom_in_left_animation.length; i++) {
			aos_zoom_in_left_animation[i].setAttribute("data-aos", "zoom-in-left");
		}
	  }
	 //  Zoom in right animation
	if (aos_zoom_in_right_animation) {
		for (let i = 0; i < aos_zoom_in_right_animation.length; i++) {
			aos_zoom_in_right_animation[i].setAttribute("data-aos", "zoom-in-right");
		}
	  }
  };